function n(e) {
  return e.value;
}
function t(e) {
  return e.value;
}
function r(e) {
  return e.value;
}
function u(e) {
  return e.label;
}
function c(e) {
  return e.id;
}
function o(e) {
  return e.name;
}
function i(e) {
  return e.title;
}
function l(e) {
  return e.key;
}
function a(e) {
  return e.key;
}
function f(e) {
  return e.count;
}
export {
  n as booleanValueSelector,
  f as numericCountSelector,
  c as numericIdSelector,
  a as numericKeySelector,
  t as numericValueSelector,
  l as stringKeySelector,
  u as stringLabelSelector,
  o as stringNameSelector,
  i as stringTitleSelector,
  r as stringValueSelector
};
